var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ParseForm',{ref:"bus",attrs:{"formParams":_vm.formParams,"formId":_vm.formId,"opCode":_vm.opCode}})
}
var staticRenderFns = []

export { render, staticRenderFns }